import React, { useState } from 'react';
import './App.css';

import { QUESTIONS_A } from './questions/questions_a';
import { QUESTIONS_B } from './questions/questions_b';
import { QUESTIONS_C } from './questions/questions_c';
import { QUESTIONS_D } from './questions/questions_d';
import { QUESTIONS_E } from './questions/questions_e';
import { QUESTIONS_F } from './questions/questions_f';
import { QUESTIONS_G } from './questions/questions_g';
import { QUESTIONS_H } from './questions/questions_h';
import { QUESTIONS_I } from './questions/questions_i';
import { QUESTIONS_J } from './questions/questions_j';
import { QUESTIONS_KL } from './questions/questions_kl';
import { QUESTIONS_M } from './questions/questions_m';
import { QUESTIONS_O } from './questions/questions_o';
import { QUESTIONS_P } from './questions/questions_p';
import { QUESTIONS_PQ } from './questions/questions_pq';
import { QUESTIONS_R } from './questions/questions_r';
import { QUESTIONS_S } from './questions/questions_s';
import { QUESTIONS_T } from './questions/questions_t';
import { QUESTIONS_U } from './questions/questions_u';
import { QUESTIONS_V } from './questions/questions_v';
import { QUESTIONS_W } from './questions/questions_w';
import { QUESTIONS_X } from './questions/questions_x';
import { QUESTIONS_L } from './questions/questions_l';

import GenreScreen from './Components/GenreScreen';
import TitleScreen from './Components/TitleScreen';
import QuizScreen from './Components/QuizScreen';
import MultiScreen from './Components/MultiScreen';
import MultiLobby from './Components/MultiLobby';
import MultiQuizScreen from './Components/MultiQuizScreen';
import BattleScreen from './Components/BattleScreen';
import BattleQuizScreen from './Components/BattleQuizScreen';
import BattleResultScreen from './Components/BattleResultScreen';

const ALL_QUESTIONS = {
  'A': QUESTIONS_A, 'B': QUESTIONS_B, 'C': QUESTIONS_C, 'D': QUESTIONS_D,
  'E': QUESTIONS_E, 'F': QUESTIONS_F, 'G': QUESTIONS_G, 'H': QUESTIONS_H,
  'I': QUESTIONS_I, 'J': QUESTIONS_J, 'KL': QUESTIONS_KL, 'M': QUESTIONS_M,
  'O': QUESTIONS_O, 'P': QUESTIONS_P, 'PQ': QUESTIONS_PQ, 'R': QUESTIONS_R,
  'S': QUESTIONS_S, 'T': QUESTIONS_T, 'U': QUESTIONS_U, 'V': QUESTIONS_V,
  'W': QUESTIONS_W, 'X': QUESTIONS_X, 'L': QUESTIONS_L
};

function App() {
  const [screen, setScreen] = useState('title'); 
  const [currentQuestions, setCurrentQuestions] = useState([]);
  const [selectedInfo, setSelectedInfo] = useState({ genreName: '', sectionId: '' });
  const [isRandomMode, setIsRandomMode] = useState(false);
  const [quizKey, setQuizKey] = useState(0);
  const [resumeIndex, setResumeIndex] = useState(0);
  const [hasResume, setHasResume] = useState(!!localStorage.getItem('quiz_resume'));

  // マルチプレイ用
  const [userName, setUserName] = useState('');
  const [roomInfo, setRoomInfo] = useState(null);

  // バトル用
  const [battleRoomInfo, setBattleRoomInfo] = useState(null);
  const [battleResultData, setBattleResultData] = useState(null);

  const handleSelectGenre = (genreId, sectionId, filters = []) => {
  const genreData = ALL_QUESTIONS[genreId];
  if (!genreData) return;

  let filtered = (sectionId === 'ALL' || !sectionId)
    ? [...genreData]
    : genreData.filter(item => item.s === sectionId);

  // ★ フィルターが選択されている場合は理解度で絞り込む
  if (filters.length > 0) {
    const levelMap = JSON.parse(localStorage.getItem('level_map') || '{}');
    filtered = filtered.filter(item => {
      const key = `${item.s}_${item.q}`;
      const level = levelMap[key] || null;
      if (filters.includes('unplayed')) {
        // 未演習 = level が null のもの
        if (level === null) return true;
      }
      return filters.includes(level);
    });

    if (filtered.length === 0) {
      alert('該当する問題がありません。フィルターを変更してください。');
      return;
    }
  }

  for (let i = filtered.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [filtered[i], filtered[j]] = [filtered[j], filtered[i]];
  }

  localStorage.removeItem('quiz_resume');
  setHasResume(false);
  setIsRandomMode(false);
  setResumeIndex(0);
  setCurrentQuestions(filtered);
  setSelectedInfo({ genreId, genreName: genreId, sectionId });
  setQuizKey(Math.random());
  setScreen('quiz');
};

  const handleSelectAllRandom = () => {
    const allData = [
      ...QUESTIONS_A, ...QUESTIONS_B, ...QUESTIONS_C, ...QUESTIONS_D,
      ...QUESTIONS_E, ...QUESTIONS_F, ...QUESTIONS_G, ...QUESTIONS_H,
      ...QUESTIONS_I, ...QUESTIONS_J, ...QUESTIONS_KL, ...QUESTIONS_M,
      ...QUESTIONS_O, ...QUESTIONS_P, ...QUESTIONS_PQ, ...QUESTIONS_R,
      ...QUESTIONS_S, ...QUESTIONS_T, ...QUESTIONS_U, ...QUESTIONS_V,
      ...QUESTIONS_W, ...QUESTIONS_X, ...QUESTIONS_L
    ];
    for (let i = allData.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [allData[i], allData[j]] = [allData[j], allData[i]];
    }

    localStorage.removeItem('quiz_resume');
    setHasResume(false);
    setIsRandomMode(true);
    setResumeIndex(0);
    setCurrentQuestions([...allData]);
    setSelectedInfo({ genreId: null, genreName: '全範囲', sectionId: 'ランダム出題' });
    setQuizKey(Math.random());
    setScreen('quiz');
  };

  // ★ 保存済み問題を演習
  const handleSelectSaved = () => {
    const saved = localStorage.getItem('saved_questions');
    if (!saved) return;
    const questions = JSON.parse(saved);
    if (questions.length === 0) return;

    for (let i = questions.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [questions[i], questions[j]] = [questions[j], questions[i]];
    }

    setIsRandomMode(false);
    setResumeIndex(0);
    setCurrentQuestions(questions);
    setSelectedInfo({ genreId: null, genreName: '保存済み', sectionId: '保存した問題' });
    setQuizKey(Math.random());
    setScreen('quiz');
  };

  const handlePause = (currentIndex) => {
    localStorage.setItem('quiz_resume', JSON.stringify({
      questions: currentQuestions,
      index: currentIndex,
      selectedInfo,
      isRandomMode,
    }));
    setHasResume(true);
    setScreen('title');
  };

  const handleResume = () => {
    const saved = localStorage.getItem('quiz_resume');
    if (!saved) return;
    const { questions, index, selectedInfo: info, isRandomMode: random } = JSON.parse(saved);
    setCurrentQuestions(questions);
    setResumeIndex(index);
    setSelectedInfo(info);
    setIsRandomMode(random);
    setQuizKey(Math.random());
    setScreen('quiz');
  };

  return (
    <div className="App">
      {screen === 'title' && (
        <TitleScreen
          onStart={() => setScreen('genre')}
          onResume={handleResume}
          hasResume={hasResume}
          onMulti={() => setScreen('multi')}
          onBattle={() => setScreen('battle')}
        />
      )}
      {screen === 'genre' && (
        <GenreScreen
          onSelect={handleSelectGenre}
          onSelectRandom={handleSelectAllRandom}
          onBack={() => setScreen('title')}
          initialGroup={selectedInfo.genreId}
          onSelectSaved={handleSelectSaved}
        />
      )}
     {screen === 'quiz' && (
  <QuizScreen 
    key={quizKey} 
    questions={currentQuestions}
    initialIndex={resumeIndex}
    onFinish={() => {
      localStorage.removeItem('quiz_resume');
      setHasResume(false);
      setResumeIndex(0);
      setSelectedInfo({ genreId: null, genreName: '', sectionId: '' }); // ★ genreIdをリセット
      setScreen('genre');
    }}
    onPause={handlePause}
    isRandom={isRandomMode} 
  />
)}

      {/* マルチプレイ */}
      {screen === 'multi' && (
        <MultiScreen
          onBack={() => setScreen('title')}
          onRoomReady={(info) => {
            setRoomInfo(info);
            setScreen('multiLobby');
          }}
          userName={userName}
          setUserName={setUserName}
        />
      )}
      {screen === 'multiLobby' && roomInfo && (
        <MultiLobby
          roomInfo={roomInfo}
          allQuestions={ALL_QUESTIONS}
          onStart={() => setScreen('multiQuiz')}
          onLeave={() => {
            setRoomInfo(null);
            setScreen('title');
          }}
        />
      )}
      {screen === 'multiQuiz' && roomInfo && (
        <MultiQuizScreen
          roomInfo={roomInfo}
          onFinish={() => {
            setRoomInfo(null);
            setScreen('title');
          }}
        />
      )}

      {/* バトル */}
      {screen === 'battle' && (
        <BattleScreen
          onBack={() => setScreen('title')}
          onGameStart={(info) => {
            setBattleRoomInfo(info);
            setScreen('battleQuiz');
          }}
          userName={userName}
          setUserName={setUserName}
          allQuestions={ALL_QUESTIONS}
        />
      )}
      {screen === 'battleQuiz' && battleRoomInfo && (
        <BattleQuizScreen
          roomInfo={battleRoomInfo}
          onFinish={(data) => {
            setBattleResultData(data);
            setScreen('battleResult');
          }}
        />
      )}
      {screen === 'battleResult' && battleResultData && (
        <BattleResultScreen
          roomData={battleResultData}
          onBack={() => {
            setBattleRoomInfo(null);
            setBattleResultData(null);
            setScreen('title');
          }}
        />
      )}
    </div>
  );
}

export default App;